import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ListarReusoCadastradoService {

  constructor(
    private http: HttpService
  ) { }

  listReusoCadastrado(data: any, successHandle: Function, errorHandle: Function) {

    return this.http.doGet('/automaticReuse/cadastradosEC', data, successHandle, errorHandle);

  }
 
}
